// Layer 3: format the optional one-off value and the fixture's human stop action.
import type { AnalysisResult } from '@/shared/contracts/analytics/v1';
import type { Case } from '@/versions/v1/schema/case';
import { assertUsd, formatCurrencyExact } from '@/versions/v1/shared/money';
import { plantRoleLabel } from './AgentInvestigation.transform';

export function stopPairRead(result?: AnalysisResult) {
  const pair = result?.one_off_stop_pair;
  if (!pair || pair.kind !== 'one_off_stop_pair') return undefined;
  assertUsd(pair.currency);
  return {
    pair,
    money: `${formatCurrencyExact(pair.planned_amount)} planned stop vs ${formatCurrencyExact(pair.avoided_failure_amount)} avoided failure`,
    basis: `${pair.planned_hours} h vs ${pair.avoided_failure_hours} h × ${formatCurrencyExact(pair.rate_per_operating_hour)}/h · capacity EBITDA`,
    qualifier: 'Conditional · one-off',
  };
}

export function stopActionRead(caseItem: Case, result?: AnalysisResult) {
  const value = stopPairRead(result);
  const candidate = result?.diagnosis?.candidates[0];
  const plan = caseItem.stopPlan;
  if (!value || !candidate?.tarp || !plan) return undefined;
  return {
    ...value,
    causeId: candidate.cause_id,
    owner: plantRoleLabel(candidate.tarp.owner_role) ?? candidate.tarp.owner_role,
    proposition: `Plan ${value.pair.planned_hours} h inspection stop · ${plan.workOrderId}`,
    approvedProposition: `Stop planned · ${value.pair.planned_hours} h inspection · ${plan.workOrderId}`,
    instruction: candidate.tarp.instruction,
    humanCheck: plan.humanCheck,
    recoveryLine: `recovers after the ${value.pair.planned_hours} h inspection and restart · ${plan.closeCriterion}`,
    window: `${plan.window.label} · ${plan.window.shift} shift`,
    windowDay: plan.window.label,
    windowShift: plan.window.shift,
  };
}
